"use strict";
/**
 * QVET Catalog
 *
 * Complete hierarchy of sections, families, and subfamilies from QVET system.
 * Source: QVET system export (Updated 2026-01-19)
 *
 * Structure: SECTION → FAMILY → SUBFAMILY[]
 * Each combination is unique and can change independently in QVET.
 *
 * Related files:
 * - Types: types/qvet.types.ts
 * - Inventory rules: constants/qvet-inventory.ts
 * - Warehouses: constants/qvet-warehouses.ts
 * - Helpers: utils/qvet-catalog.helpers.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QVET_SECTIONS_LIST = exports.QVET_SECTION_ID_BY_NAME = exports.QVET_SECTION_IDS = exports.QVET_SECTIONS = void 0;
// =============================================================================
// SECTIONS (Single source of truth for section strings)
// =============================================================================
/**
 * @deprecated Diez secciones escritas a mano; en QVET hay **veinte**. Medido el 2026-09-09:
 * 22 artículos viven en secciones que esta lista no nombra, así que el filtro del catálogo no
 * los alcanza. El árbol real llega por `GET /api/catalog-items/catalogs` (`classification`).
 * Se borra con el despliegue de GH527.
 */
exports.QVET_SECTIONS = {
    CONSUMO_INTERNO: 'CONSUMO INTERNO',
    EQUIPAMIENTO: 'EQUIPAMIENTO',
    FARMACIA: 'FARMACIA',
    FARMACIA_INTERNA: 'FARMACIA INTERNA',
    INSUMOS_ESCANDALLO: 'INSUMOS ESCANDALLO',
    INSUMOS_MEDICOS: 'INSUMOS MEDICOS',
    OTROS_ARTICULOS: 'OTROS ARTICULOS',
    OTROS_SERVICIOS: 'OTROS SERVICIOS',
    SERVICIOS_EXTERNOS: 'SERVICIOS EXTERNOS',
    SERVICIOS_MEDICOS: 'SERVICIOS MEDICOS',
};
// =============================================================================
// Aquí vivía QVET_CATALOG — borrado el 2026-09-08
// =============================================================================
//
// 🚨 Era **una copia a mano del árbol de QVET**: 10 secciones, 69 familias y 98 líneas
// escritas y mantenidas por nosotros. La realidad, medida el mismo día contra el catálogo
// sincronizado: **20 secciones, 162 familias y 444 subfamilias**. O sea que la copia tenía
// **la mitad** de lo que existe, y llevaba quién sabe cuánto sin actualizarse.
//
// **Se borra en vez de migrarse porque no lo leía nadie**: de los ocho ayudantes que colgaban
// de él, **siete tenían cero consumidores**; el octavo, `requiresExpirationDate`, no lo usaba
// —le bastan las dos constantes de caducidad—. El tipo `QvetCatalog` tampoco: su único
// «uso» era la cadena `'QvetCatalog'`, el nombre de un modelo de Mongoose.
//
// El árbol de verdad se sincroniza desde QVET (`Familia` y `SubFamilia`, en cascada) y se
// sirve por `GET /api/catalog-items/catalogs`, con su bandera de alta y por id.
// =============================================================================
// DERIVED LISTS
// =============================================================================
/**
 * All section values as array
 *
 * @deprecated Diez secciones escritas a mano; en QVET hay **veinte**. Medido el 2026-09-09:
 * 22 artículos viven en secciones que esta lista no nombra, así que el filtro del catálogo no
 * los alcanza. El árbol real llega por `GET /api/catalog-items/catalogs` (`classification`).
 * Se borra con el despliegue de GH527.
 */
/**
 * The **QVET id** of each section, measured against the synced catalog on 2026-09-11.
 *
 * 🚨 **Prefer these over the names.** QVET renames things, and a rule matched by name simply
 * stops applying the day it does — silently. The ids are stable across renames; a name is a
 * label. See `.claude/rules/modelos-y-qvet.md`, rule 3: a live link stores the id.
 *
 * These ten are QVET's **active** sections. The other ten (ids 1-9 and 11) are retired:
 * HONORARIOS, HISTORICO, PELUQUERIA, MASCOTAS, SERVICIO A DOMICILIO, LABORATORIO, FCM,
 * GASTOS GENERALES, PRUEBAS DE GABINETE and one migration leftover. They carry no pricing
 * rules on purpose — nothing new is created in them.
 */
exports.QVET_SECTION_IDS = {
    SERVICIOS_MEDICOS: 10,
    OTROS_SERVICIOS: 12,
    SERVICIOS_EXTERNOS: 13,
    FARMACIA: 14,
    FARMACIA_INTERNA: 15,
    INSUMOS_MEDICOS: 16,
    OTROS_ARTICULOS: 17,
    CONSUMO_INTERNO: 18,
    EQUIPAMIENTO: 19,
    INSUMOS_ESCANDALLO: 20,
};
/** The id of a section, looked up by the name QVET's reports carry. */
exports.QVET_SECTION_ID_BY_NAME = {
    [exports.QVET_SECTIONS.SERVICIOS_MEDICOS]: exports.QVET_SECTION_IDS.SERVICIOS_MEDICOS,
    [exports.QVET_SECTIONS.OTROS_SERVICIOS]: exports.QVET_SECTION_IDS.OTROS_SERVICIOS,
    [exports.QVET_SECTIONS.SERVICIOS_EXTERNOS]: exports.QVET_SECTION_IDS.SERVICIOS_EXTERNOS,
    [exports.QVET_SECTIONS.FARMACIA]: exports.QVET_SECTION_IDS.FARMACIA,
    [exports.QVET_SECTIONS.FARMACIA_INTERNA]: exports.QVET_SECTION_IDS.FARMACIA_INTERNA,
    [exports.QVET_SECTIONS.INSUMOS_MEDICOS]: exports.QVET_SECTION_IDS.INSUMOS_MEDICOS,
    [exports.QVET_SECTIONS.OTROS_ARTICULOS]: exports.QVET_SECTION_IDS.OTROS_ARTICULOS,
    [exports.QVET_SECTIONS.CONSUMO_INTERNO]: exports.QVET_SECTION_IDS.CONSUMO_INTERNO,
    [exports.QVET_SECTIONS.EQUIPAMIENTO]: exports.QVET_SECTION_IDS.EQUIPAMIENTO,
    [exports.QVET_SECTIONS.INSUMOS_ESCANDALLO]: exports.QVET_SECTION_IDS.INSUMOS_ESCANDALLO,
};
exports.QVET_SECTIONS_LIST = Object.values(exports.QVET_SECTIONS);
